import { Action } from '@ngrx/store';
import { Creep } from '../creep';

export const ADD_CREEP = '[Creep] Add';
export const REMOVE_CREEP = '[Creep] Remove';
export const UPDATE_CREEP = '[Creep] Update';
export const RESTORE_CREEPS = '[Creep] Restore';

export class AddCreepAction implements Action {
  readonly type = ADD_CREEP;

  constructor(public payload: Creep) { }
}

export class RemoveCreepAction implements Action {
  readonly type = REMOVE_CREEP;

  constructor(public payload: Creep) { }
}

export class UpdateCreepAction implements Action {
  readonly type = UPDATE_CREEP;

  constructor(public payload: [Creep, Creep]) { }
}

export class RestoreCreepsAction implements Action {
  readonly type = RESTORE_CREEPS;

  constructor(public payload: Creep[]) { }
}

export type Actions
  = AddCreepAction
  | RemoveCreepAction
  | UpdateCreepAction
  | RestoreCreepsAction;



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/store.module/creeps.actions.ts